import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }
    setSelects(data) {
        this.setState({
            tipo_id: data.tipo_id,
        });
    }
    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.subtipos.edit}
                postUrl={api.proyectos.config.plan.subtipos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Subtipo de Transferencia ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Subtipo de Transferencia"}
                buttonTitle={"Editar Subtipo de Transferencia"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Tipo</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker value={this.state.tipo_id} onChange={(value) => this.setState({ tipo_id: value.pk })} fieldName={"tipo_id"} url={api.proyectos.config.plan.tipos.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_SubTipos/Edit.js